import { z } from 'zod';
import type { OrderStatus, PaymentMethod } from '@pc/db';

export const STATUS_LABELS: Record<OrderStatus, string> = {
  draft: 'Draft',
  proposal_sent: 'Proposal sent',
  approved: 'Approved',
  declined: 'Declined',
  invoiced: 'Invoiced',
  partially_paid: 'Partially paid',
  paid: 'Paid',
  overpaid: 'Overpaid',
  fulfilled: 'Fulfilled',
  cancelled: 'Cancelled',
  voided: 'Voided',
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  manual: 'Manual',
  cash: 'Cash',
  check: 'Check',
  wire: 'Wire',
  ach: 'ACH',
  card: 'Card',
  other: 'Other',
};

export const LineForm = z.object({
  description: z.string().min(1, 'Required').max(500),
  quantity: z.coerce.number().positive('Quantity > 0'),
  unitPrice: z.coerce.number().min(0, 'Cannot be negative'),
  discount: z.coerce.number().min(0).default(0),
});
export type LineForm = z.infer<typeof LineForm>;

export const PaymentForm = z.object({
  amount: z.coerce.number().positive('Amount must be > 0'),
  method: z.enum(['manual', 'cash', 'check', 'wire', 'ach', 'card', 'other']),
  reference: z.string().max(120).optional(),
  notes: z.string().max(500).optional(),
  paidAt: z.string().optional(),
});
export type PaymentForm = z.infer<typeof PaymentForm>;
